import React from "react";
import StatusPipeline from "./StatusPipeline"; // Ensure you created this in Phase 1

export default function OdooFormLayout({
  title,
  subTitle,
  status,
  stages = [], // Array of strings ["Draft", "Pending", "Approved"]
  actions,     // React Fragment of Buttons (Save, Confirm, etc.)
  smartButtons, // React Fragment of SmartButtons
  children
}) {
  return (
    <div className="flex flex-col h-full bg-gray-100 dark:bg-[#0d1117] font-sans text-sm transition-colors">
      

{/* 1. CONTROL PANEL (Sticky Header) */}
<div className="bg-white dark:bg-[#161b22] border-b border-gray-200 dark:border-[#30363d] sticky top-0 z-20 px-4 py-2 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shadow-sm min-h-[60px] transition-colors">
  
  {/* Left: Action Buttons (🟢 UPDATED: Added flex-wrap, removed overflow-x-auto) */}
  <div className="flex flex-wrap items-center gap-2 w-full md:w-auto pb-2 md:pb-0">
    {actions}
  </div>

  {/* Right: Status Pipeline */}
  <div className="hidden md:block w-full md:w-auto overflow-x-auto">
      <StatusPipeline stages={stages} currentStage={status} />
  </div>
</div>

      {/* 2. SCROLLABLE CONTENT AREA */}
      <div className="flex-1 overflow-auto p-4 md:p-6 flex justify-center">
        
        {/* THE WHITE SHEET */}
        <div className="bg-white dark:bg-[#161b22] border border-gray-300 dark:border-[#30363d] shadow-sm rounded w-full max-w-[1100px] min-h-[800px] flex flex-col relative transition-colors">
            
            {/* Smart Buttons Area */}
            {smartButtons && (
                <div className="absolute top-0 right-0 p-0 flex flex-row-reverse rounded-tr overflow-hidden">
                    {smartButtons}
                </div>
            )}

            <div className="p-8 md:p-10">
                {/* Title Section */}
                <div className="mb-8 flex justify-between items-start">
                    <div>
                        <h1 className="text-xl font-bold text-gray-800 dark:text-white mb-2">{title}</h1>
                        {subTitle && <div className="text-lg text-gray-500 dark:text-slate-400">{subTitle}</div>}
                    </div>
                </div>

                {/* Main Form Content */}
                {children}
            </div>
        </div>
      </div>
    </div>
  );
}